/**
 * Prevent scrollbar adding-up to the width of page,
 * and thus prevent content jumping when changing overflow.
 */
export function setContentWithScrollWidth() {
  document.body.style.width = '100vw';
  document.body.style.overflowX = 'hidden';
}
export function unsetContentWithScrollWidth() {
  document.body.style.width = 'unset';
  document.body.style.overflowX = 'unset';
}
export function lockScroll() {
  document.body.style.overflowY = 'hidden';
}
export function unlockScroll() {
  /**
   * Some pages, like iframes, always required scroll to be locked.
   * Then, use ScrollLock which applies `scroll-locked` attribute on body,
   * which will prevent unlocking scroll on such pages.
   */
  if (!document.body.hasAttribute('scroll-locked')) {
    document.body.style.overflowY = 'auto';
  }
}